import { Modal } from '@mui/material';
import { X } from 'react-feather';
import { COLORS } from '../../../utils/colors';
import React, { useEffect, useState } from 'react';
import { AppButton } from '../AppButton/AppButton';
import { AppInputField } from '../AppInputField/AppInputField';
import { useAppDispatch } from '../../../redux/store';
import { DillTransaction } from '@dill/dill-shared/dist/src';
import { openDillToast } from '../../../utils/helpers';
import { resendInvoicePdfReceipt } from '../../../redux/services/paymentsService';

export const ResendReceiptModal = ({
  open,
  selectedTransaction,
  handleClose,
}: {
  open: boolean;
  selectedTransaction: DillTransaction | null;
  handleClose: () => void;
}) => {
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState('');
  const [isSendingRecceipt, setIsSendingRecceipt] = useState(false);
  const [error, setError] = useState('');

  const handleCloseModal = () => {
    setEmail('');
    setError('');
    handleClose();
  };

  useEffect(() => {
    if (selectedTransaction) {
      if (
        selectedTransaction.type !== 'PAYMENT_REQUEST_PAYMENT' &&
        selectedTransaction.type !== 'WILL_CALL_PAYMENT' &&
        selectedTransaction.sender?.user?.email
      ) {
        setEmail(selectedTransaction.sender?.user?.email);
      } else if (
        selectedTransaction.type === 'PAYMENT_REQUEST_PAYMENT' &&
        selectedTransaction.paymentRequest?.paymentConfirmationEmail
      ) {
        setEmail(selectedTransaction.paymentRequest?.paymentConfirmationEmail);
      } else if (selectedTransaction.type === 'WILL_CALL_PAYMENT') {
        const receiptEmails = selectedTransaction?.receiptEmails || [];
        const senderEmail = selectedTransaction.sender?.user?.email;
        setEmail(receiptEmails.length > 0 ? receiptEmails[0] : senderEmail ? senderEmail : '');
      }
    }
    return () => {};
  }, [selectedTransaction]);

  const handleResendReceipt = async () => {
    try {
      if (!email) {
        setError('Email is required');
        return;
      }

      const emailRegex = /[\w.+-]+@[\w-]+\.[a-z]{1,}/gi;
      const isMatch = emailRegex.test(email);
      if (!isMatch) {
        setError('Email is not valid');
        return;
      }
      if (!selectedTransaction?.id) {
        openDillToast({ message: 'Transaction ID not found', type: 'ERROR' });
        return;
      }
      setIsSendingRecceipt(true);
      const resendInvoicePdfReceiptRes = await dispatch(
        resendInvoicePdfReceipt({
          supplierId: selectedTransaction.supplierId,
          transactionId: selectedTransaction.id,
          email,
        })
      );
      setIsSendingRecceipt(false);

      if (
        resendInvoicePdfReceiptRes &&
        resendInvoicePdfReceiptRes.type === 'payments/resendInvoicePdfReceipt/fulfilled'
      ) {
        openDillToast({
          message: 'Receipt resent successfully',
          type: 'SUCCESS',
        });
        handleCloseModal();
      } else {
        let errorMsg = '';
        if (resendInvoicePdfReceiptRes?.payload) {
          const payload: any = resendInvoicePdfReceiptRes?.payload;
          errorMsg = payload || '';
        }
        openDillToast({ message: `Error resending receipt.\n${errorMsg}`, type: 'ERROR' });
      }
    } catch (err: any) {
      openDillToast({ message: err.message || 'Failed to resend receipt', type: 'ERROR' });
      console.log(err);
    }
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg flex-col w-[412px]">
        <X
          className="absolute right-4 top-4 cursor-pointer"
          color={COLORS.GREY_500}
          onClick={handleCloseModal}
        />
        <div className="text-lg font-semibold my-3 mt-10 w-full item-center text-center">
          Resend Receipt
        </div>
        <div className="flex flex-col w-full p-4">
          <AppInputField
            isRequired={true}
            label={'Enter email address to resend receipt'}
            inputType="email"
            errorText={error}
            onTextChange={(text) => {
              setEmail(text);
              setError('');
            }}
            value={email}
          />
        </div>
        <div className="flex flex-row m-3 gap-2 items-center justify-center">
          <AppButton
            text={'Cancel'}
            type="TERTIARY"
            buttonStyles={{ marginLeft: '10px', marginRight: '10px' }}
            onClick={handleCloseModal}
          />
          <AppButton
            text={'Send'}
            isLoading={isSendingRecceipt}
            isDisabled={isSendingRecceipt}
            buttonStyles={{ marginLeft: '10px', marginRight: '10px' }}
            onClick={handleResendReceipt}
          />
        </div>
      </div>
    </Modal>
  );
};
